import { render, staticRenderFns } from "./SalesPerWeekTable.vue?vue&type=template&id=7ff53c6b&"
import script from "./SalesPerWeekTable.vue?vue&type=script&lang=js&"
export * from "./SalesPerWeekTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports